// Generated by ReScript, PLEASE EDIT WITH CARE

import VehicleCategoryMappingJson from "../../partner-web-apps/insurance-dashboard/view/assets/VehicleCategoryMapping.json";
import GeoregionVehicleEligibleConfigJson from "../../partner-web-apps/insurance-dashboard/view/assets/GeoregionVehicleEligibleConfig.json";

var vehicleTypeCategoryMapper = VehicleCategoryMappingJson;

var vehicleGeoregionConfig = GeoregionVehicleEligibleConfigJson;

export {
  vehicleTypeCategoryMapper ,
  vehicleGeoregionConfig ,
  
}
/* vehicleTypeCategoryMapper Not a pure module */
